import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import parse from "html-react-parser";

import { fetchFaqs } from "../../redux/slice/faqs/faqs";

import "./Faqs.scss";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer2";

const Faqs = () => {
  const dispatch = useDispatch();
  const { faqsData, loading } = useSelector((state) => state.faqs);

  useEffect(() => {
    dispatch(fetchFaqs());
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Header />
      <div className="faqpage">
        <div className="home-bg">
          <div className="heading">
            <p className="redtext">FAQs</p>
            <h1 className="faqtext">Frequently Asked Questions</h1>
          </div>
        </div>
      </div>
      <div className="faq-content">
        <div className="accordion" id="accordionExample">
          {faqsData?.map((faq, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  {faq?.attributes?.Questions}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${
                  index === 0 ? "show" : ""
                }`}
                aria-labelledby={`heading${index}`}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  {parse(faq?.attributes?.Answer)}
                </div>
              </div>
            </div>
          ))}
          {loading && faqsData?.length === 0 ? (
            <div className="spinner_table_height">
              <Spinner color="black" />
            </div>
          ) : null}
        </div>
      </div>
      {/* <div className="white-box ">
        <div className="whitebg">
          <div className="faq-foot">
            <div className="faqfoot-content">
              <p className="contenthead">Stop window shopping for rewards</p>
              <p className="contentsub">
                Set up and begin earning within minutes.
                <span className="highlighttext">                  
                  Sign up for free to start earning & spending
                </span>
              </p>
              <button>Create your Own Account</button>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default Faqs;
